import { SET_COMPONENT_IN_STORE } from '../constants/actionTypes';

export function setComponent(component) {
  return {
    type: SET_COMPONENT_IN_STORE,
    component
  };
}
